import {
  PlaidAssetReportStatus,
  RequiredDocument,
} from '../../../../../../../../../../types/api';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Rule } from '../../interfaces/Rule';
import loanFormModelOriginal from '../../form_models/loanFormModel';

const {
  documents: { plaidAssetReport },
} = loanFormModelOriginal.formField;

class HasPlaidAssetReport implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const reportStatus = application[plaidAssetReport.name]
      ?.asset_report_status as PlaidAssetReportStatus | undefined;

    const hasPlaidFromField = reportStatus === PlaidAssetReportStatus.SUCCESS;

    const plaidAssetReportReqDocument =
      application.required_documents?.some(
        (reqDoc: RequiredDocument) =>
          reqDoc.document_type?.name === 'Plaid Asset Report' &&
          Array.isArray(reqDoc.files) &&
          reqDoc.files.length > 0
      ) ?? false;

    return hasPlaidFromField || plaidAssetReportReqDocument;
  }
}

export default new HasPlaidAssetReport();
